import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 0,
  pageSize: 25
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setPagination: (state, action) => {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
    },
    resetPagination: (state) => {
        state.page = initialState.page;
        state.pageSize = initialState.pageSize;
      }
  }
});

export const { setPagination,resetPagination } = paginationSlice.actions;
export default paginationSlice.reducer;
